import posthog from 'posthog-js'

export function usePostHog() {
    posthog.init('phc_zDNACj3htcvDj4qGnIFTG4WuOvnWaDwv7hCN4PVVzMT', {
        api_host: 'https://eu.i.posthog.com',
        defaults: '2025-11-30',
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    })

    return { posthog }
}